import { useLayoutEffect } from 'react';
import { ANIMATE_ON_ORIENTATION, ANIMATE_ON_OPEN } from '../../../context/constants';
import { useAnimationHandlersContext } from '../../../context/useAnimationContext';

export const useAddAnimationOnOrientationChange = () => {
    const { handleSetContainerClasses, handleRemoveContainerClasses, resetAnimateOnOpen } = useAnimationHandlersContext();

    useLayoutEffect(() => {
        const handleSetClasses = () => {
            handleRemoveContainerClasses(ANIMATE_ON_OPEN);
            handleSetContainerClasses(ANIMATE_ON_ORIENTATION);
            resetAnimateOnOpen();
        };
        window.addEventListener('resize', handleSetClasses);

        return () => {
            window.removeEventListener('resize', handleSetClasses);
            handleRemoveContainerClasses(ANIMATE_ON_OPEN);
            handleRemoveContainerClasses(ANIMATE_ON_ORIENTATION);
        };
    }, [handleRemoveContainerClasses, handleSetContainerClasses, resetAnimateOnOpen]);
};
